import React from 'react'
import { graphql, useFragment } from 'react-relay'
import { Trans } from '@lingui/react/macro'

import { XStack } from 'tamagui'

import { Card } from '../Card'
import { Icon } from '../Icon'
import { Link } from '../Link'
import { Text } from '../Text'

import { GuildNetworkRequestsLink_guild$key } from './__generated__/GuildNetworkRequestsLink_guild.graphql'

/**
 * Tells a Network's Organizers, on the Network's own page, that Guilds are
 * waiting for an answer to their join request, and links to the review list.
 */
export const GuildNetworkRequestsLink = ({
  guild,
}: {
  guild: GuildNetworkRequestsLink_guild$key
}) => {
  const data = useFragment(
    graphql`
      fragment GuildNetworkRequestsLink_guild on Guild {
        slugId
        type

        myMembership {
          membershipLevel
        }

        pendingNetworkRequests: rankedNetworkGuilds(
          membershipStatus: PENDING
          first: 1
        ) {
          totalCount
        }
      }
    `,
    guild
  )

  const count = data.pendingNetworkRequests.totalCount

  if (
    data.type !== 'NETWORK' ||
    data.myMembership?.membershipLevel !== 'ORGANIZER' ||
    count === 0
  ) {
    return null
  }

  return (
    <Link
      href={`/${data.slugId}/settings/network`}
      hoverStyle={{ textDecorationLine: 'none' }}
    >
      <Card
        padding='$3'
        paddingHorizontal='$4'
        borderWidth={1}
        borderColor='$borderColor'
        hoverStyle={{ backgroundColor: '$backgroundHover' }}
      >
        <XStack gap='$3' alignItems='center'>
          <Icon name='organization' size='$5' color='$primaryColor' />

          <Text size='$4' fontWeight='$6' flex={1}>
            {count === 1 ? (
              <Trans>1 Guild wants to join your Network</Trans>
            ) : (
              <Trans>{count} Guilds want to join your Network</Trans>
            )}
          </Text>

          <Icon name='arrow-right' size='$4' color='$colorMuted' />
        </XStack>
      </Card>
    </Link>
  )
}
